import CreditCardBlock from './CreditCardBlock'

export default CreditCardBlock
